<template>
  <div>
    <NotFound />
  </div>
</template>
<script>
import NotFound from '@/components/NotFound'
export default {
  components: {
    NotFound,
  }
}
</script>